import React, { useEffect, useRef, useState } from 'react'
import { FaSearch } from 'react-icons/fa'
import { useSearchParams } from 'react-router-dom'
import adminServices from '../../services/AdminServices'
import Loading from '../feedback/Loading'
import FetchError from '../feedback/FetchError'
import StoresList from '../admin/StoresList'
import StoreModal from '../vendor/StoreModal'
import StoreStats from '../admin/StoreStats'

function StoresTab() {
    const [activeStore, setActiveStore] = useState()
    const [searchParams, setSearchParams] = useSearchParams()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState()
    const [stores, setStores] = useState()
    const searchInputRef = useRef();
    const [action, setAction] = useState(0)

    useEffect(() => {
        getStores()
    }, [])

    useEffect(() => { }, [loading])
    useEffect(() => { }, [error])
    useEffect(() => { }, [stores])
    useEffect(() => { }, [activeStore])
    useEffect(() => { }, [action])
    useEffect(() => {
        const params = searchParams.toString()
        if (params) {
            getStores(params)
        }
    }, [searchParams])

    const getStores = (params) => {
        setError()
        setLoading(true)
        adminServices.getStores(params ? `?${params}` : '').then(
            res => {
                setStores(res.data)
                setLoading(false)
            },
            err => {
                console.log(err);
                setError(err)
                setLoading(false)
            }
        )
    }

    function changePageParam(page) {
        if (page) {
            setSearchParams((params) => {
                params.set("page", page)
                return params
            })
        } else {
            setSearchParams((params) => {
                params.delete("page")
                return params
            })
            getStores()
        }
    }

    const handleSearch = (e) => {
        if (e.key === 'Enter') {
            const query = e.target.value.trim();
            setSearchParams(prev => {
                const newParams = new URLSearchParams(prev);
                if (query) {
                    newParams.set('search', query);
                } else {
                    newParams.delete('search');
                    getStores()
                }
                newParams.delete('page');
                return newParams;
            });
        }
    };

    function openModal(action, store) {
        const openBtn = document.getElementById("store-open-btn")
        if (action === 0) {
            setAction(0)
        }
        if (action === 1) {
            setAction(1)
            setActiveStore(store)
        }
        openBtn.click()
    }
    return (
        <div className='space-y-6'>
            <StoreStats />

            <div className="flex justify-between items-center">
                <h1 className="text-2xl font-bold text-gray-800">Stores</h1>
                {stores ? (
                    <div>
                        <p className='text-lg font-semibold text-gray-600'>Store Count: <span className='text-primary'>{"("}{stores?.count}{")"}</span></p>
                    </div>
                ) : null}
            </div>
            <div className="space-y-6">
                <div className="flex flex-col md:flex-row items-center justify-between">
                    <div className="relative w-full md:w-80">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                            <FaSearch />
                        </span>
                        <input
                            ref={searchInputRef}
                            className="w-full pl-10 pr-10 py-2 border rounded-lg focus:ring-primary focus:border-primary"
                            placeholder="Search users by name or owner ..."
                            type="text"
                            onKeyDown={handleSearch}
                            defaultValue={searchParams.get('search') || ''}
                        />
                    </div>
                </div>
                <StoreModal
                    action={action}
                    activeStore={activeStore}
                    getStores={getStores}
                />
                {loading ? (
                    <div className='py-9'>
                        <Loading />
                    </div>
                ) : (
                    <div>
                        {error ? (
                            <div><FetchError error={error} /></div>
                        ) : (
                            <div>
                                <StoresList
                                    openModal={openModal}
                                    stores={stores}
                                    changePageParam={changePageParam}
                                />
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}

export default StoresTab